import { MantineProvider, createTheme } from '@mantine/core';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme = createTheme({
  fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif",
  fontFamilyMonospace: "'JetBrains Mono', ui-monospace, Menlo, Consolas, monospace",
  headings: { fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif" },
  primaryColor: 'yellow',
});

root.render(
  <React.StrictMode>
    <MantineProvider defaultColorScheme="dark" theme={theme}>
      <App />
    </MantineProvider>
  </React.StrictMode>
);
